import { jsx as t } from "react/jsx-runtime";
import { c as f } from "react/compiler-runtime";
import { Chip as l } from "@mui/material";
function c(p) {
  const r = f(6);
  let e, i;
  r[0] !== p ? ({
    children: e,
    ...i
  } = p, r[0] = p, r[1] = e, r[2] = i) : (e = r[1], i = r[2]);
  let o;
  return r[3] !== e || r[4] !== i ? (o = /* @__PURE__ */ t(l, { ...i, children: e }), r[3] = e, r[4] = i, r[5] = o) : o = r[5], o;
}
export {
  c as Chip
};
